
<div :class="{'drag-item': true, 'show': open}">
  <cvt-button
    v-if="!open"
    color="dark"
    icon="cvt-icon-plus"
    class="add-button-drag"
    size="xl"
    @click="() => openOrClose(true)"
  />
  <div :class="{'d-flex h-100': true, 'drag-item__collapse': !open}">
    <div :class="{'drag-item__container': true, 'open': open}">
      <cvt-button
        color="dark"
        icon="cvt-icon-plus"
        class="add-button-drag rotate-plus-to-close"
        size="xl"
        @click="() => openOrClose(false)"
      />
      <div
        v-for="item of dragItems"
        :id="item.id + '~' + vnodeId"
        :key="'btn-' + item.name"
        :class="newWidgetClasses"
        :gs-w="item[viewMode].w"
        :gs-h="item[viewMode].h"
        :data-gs-width="item[viewMode].w"
        :data-gs-height="item[viewMode].h"
        draggable="true"
      >
        <div
          :id="item.name + '~' + vnodeId"
          class="grid-stack-item-content drag-item__icon"
        >
          <i
            :title="item.name"
            role="presentation"
            :class="`icon ${item.icon} hover`"
            size="md"
            orgname="standard"
            prepend="true"
            text=""
          />
          <!--          {{ item.name }}-->
        </div>
      </div>
      <cvt-tooltip
        v-for="item of dragItems"
        :key="'tooltip-' + item.name + vnodeId"
        :target="item.id + '~'+vnodeId"
        size="xs"
      >
        <strong>{{ item.label }}</strong>
      </cvt-tooltip>
    </div>
  </div>
</div>
